module.exports = __webpack_public_path__ + "assets/road-sign-right.0138b227.svg";